export { default as RequestDetails } from './hocs';
